import { Component, Input } from '@angular/core';
import { AncillaryTypeModel, ProjectModel } from '../../../../hub_schema/hubTypes';
import { HubRecordPresenterBase } from '../../../shared/components/_hub_record_presenter_base';

@Component({
    selector: 'app-summary-container',
    templateUrl: './summary-container.component.html',
    styleUrls: ['./summary-container.component.scss'],
    standalone: false
})
export class SummaryContainerComponent extends HubRecordPresenterBase {
    @Input()
    public override project: ProjectModel;
}
